import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { MenuItem, Paper, withStyles } from '@material-ui/core';
import { FHETextField } from '.';

class FHEBoxAutoComplete extends PureComponent {
    static propTypes = {
        disabled: PropTypes.bool,
        baseValue: PropTypes.string,
        data: PropTypes.array.isRequired,
        name: PropTypes.string.isRequired,
        id: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        selectData: PropTypes.func.isRequired,
        classes: PropTypes.object.isRequired,
        error: PropTypes.oneOfType([PropTypes.string, PropTypes.array])
    };

    static defaultProps = {
        disabled: false,
        error: null,
        baseValue: ''
    };

    constructor(props) {
        super(props);
        this.MAX_SIZE_ITEMS = 50;

        this.state = {
            value: props.baseValue,
            displaySelectMenu: true,
            macMode: true
        };
    }

    onMouseDown = (mac, id) => {
        const { selectData, name } = this.props;
        this.setState({
            value: mac,
            displaySelectMenu: false
        });

        selectData(name, mac, id);
    };

    handleChange = event => {
        const regex = /[A-F0-9]{0,12}/g;
        let value = event.target.value.replace(/:/g, '');
        value = value.toUpperCase().match(regex)[0];

        this.setState({
            value
        });
    };

    onFocus = () => {
        const { displaySelectMenu } = this.state;
        if (!displaySelectMenu) {
            this.setState({
                displaySelectMenu: true
            });
        }
    };

    onBlur = () => {
        const { displaySelectMenu } = this.state;
        if (displaySelectMenu) {
            this.setState({
                displaySelectMenu: false
            });
        }
    };
    renderListItem = (value, data) => {
        const inputValue = value.toUpperCase().replace(/:/g, '');
        let res = [];
        let cpt = 0;
        for (let i = 0; i < data.length; i++) {
            const datum = data[i];
            const macMatched = datum.mac.includes(inputValue);
            const idMatched = datum.id.toString().includes(inputValue);
            if (macMatched || idMatched) {
                this.state.macMode = !idMatched;
                cpt++;
                res.push(
                    <MenuItem key={datum.mac} component="div" onMouseDown={this.onMouseDown.bind(this, datum.mac, datum.id)}>
                        {`${datum.mac.match(/.{1,2}/g).join(':')} ( ID: ${datum.id} )`}
                    </MenuItem>
                );
            }
            if (cpt >= this.MAX_SIZE_ITEMS) break;
        }
        if (cpt === 0)
            return (
                <MenuItem key="noResult" component="div" disabled>
                    {Translator.translate('general.noResults')}
                </MenuItem>
            );
        return res;
    };

    render() {
        const { value, displaySelectMenu } = this.state;
        const { disabled, error, label, id, name, classes, data } = this.props;
        const listItem = this.renderListItem(value, data);

        return (
            <div className={classes.autocompleteContainer}>
                <FHETextField
                    autoComplete="off"
                    id={id}
                    name={name}
                    disabled={disabled}
                    value={this.state.macMode && value.length > 0 ? value.match(/.{1,2}/g).join(':') : value}
                    error={error}
                    label={label}
                    onChange={this.handleChange}
                    onFocus={this.onFocus}
                    onBlur={this.onBlur}
                />

                <div className={classes.suggestionsContainer}>
                    {displaySelectMenu && (
                        <Paper square elevation={1}>
                            {listItem}
                        </Paper>
                    )}
                </div>
            </div>
        );
    }
}

const styles = () => ({
    autocompleteContainer: {
        width: '100%',
        position: 'relative'
    },
    suggestionsContainer: {
        width: '100%',
        position: 'absolute',
        zIndex: 20,
        maxHeight: 200,
        overflowY: 'scroll'
    }
});

export default withStyles(styles, { withTheme: true })(FHEBoxAutoComplete);



// WEBPACK FOOTER //
// ./data/components/FHEBoxAutoComplete.js